import Axios from "axios";
import Store from "../store/store";
import { baseUrls } from "../settings";

const CHAVE_STORAGE = "servicobusca_smarthint_session";
const TEMPO_LIMITE_SESSAO_MS = 10000;
const MAXIMO_INTEIRO_SEGURO = 9007199254740991;
let renovacaoPendente = null;
let chaveRenovacao = null;

function ler() {
    try {
        const valorArmazenado = localStorage.getItem(CHAVE_STORAGE);

        if (!valorArmazenado) {
            return null;
        }

        const sessao = JSON.parse(valorArmazenado);
        return sessao && typeof sessao === "object" ? sessao : null;
    } catch (e) {
        remover();
        return null;
    }
}

function remover() {
    try {
        localStorage.removeItem(CHAVE_STORAGE);
    } catch (e) {
        return;
    }
}

function normalizarTexto(valor) {
    const texto = String(valor == null ? "" : valor).trim();
    return texto !== "" ? texto : null;
}

function obterExpiracaoEmMilissegundos(expiracao) {
    if (expiracao == null || expiracao === "") {
        return null;
    }

    const expiracaoNumerica = Number(expiracao);

    if (isFinite(expiracaoNumerica) && expiracaoNumerica > 0) {
        return expiracaoNumerica < 1000000000000
            ? expiracaoNumerica * 1000
            : expiracaoNumerica;
    }

    const expiracaoData = Date.parse(expiracao);
    return isNaN(expiracaoData) ? null : expiracaoData;
}

function obterContextoValido(sessao) {
    if (!sessao) {
        return null;
    }

    const valorNumerico = Number(sessao.valor);
    const anonymousConsumer = normalizarTexto(sessao.anonymousConsumer);
    const expiracao = obterExpiracaoEmMilissegundos(sessao.expiracao);

    if (
        !isFinite(valorNumerico) ||
        Math.floor(valorNumerico) !== valorNumerico ||
        valorNumerico <= 0 ||
        valorNumerico > MAXIMO_INTEIRO_SEGURO ||
        !anonymousConsumer || !expiracao || expiracao <= Date.now()
    ) {
        return null;
    }

    return {
        valor: String(valorNumerico),
        anonymousConsumer
    };
}

function obterUrlSessao() {
    if (window.servicobusca && window.servicobusca.urlSessao) {
        return window.servicobusca.urlSessao;
    }

    throw new Error("URL da sessão do serviço de busca não configurada.");
}

function salvarSessao(dados) {
    const sessao = {
        valor: dados.valorSessao,
        expiracao: dados.dhExpiracao,
        anonymousConsumer: dados.SmartHint_AnonymousConsumer
    };

    const contexto = obterContextoValido(sessao);

    if (!contexto) {
        throw new Error("Sessão inválida retornada pelo serviço de busca.");
    }

    localStorage.setItem(CHAVE_STORAGE, JSON.stringify(sessao));
    return contexto;
}

function renovar() {
    const chave = Store.state.login.xApiKey;
    if (renovacaoPendente && chaveRenovacao === chave) {
        return renovacaoPendente;
    }

    const requisicao = chave
        ? Axios.post(`${baseUrls.api}/produto/preparar-servico-busca`, null, {
            headers: { "X-Api-Key": chave },
            withCredentials: true,
            timeout: TEMPO_LIMITE_SESSAO_MS
        })
        : Axios.get(obterUrlSessao(), {
            withCredentials: true,
            timeout: TEMPO_LIMITE_SESSAO_MS
        });

    let promessa = requisicao.then((response) => {
        if (Store.state.login.xApiKey !== chave) {
            throw new Error("A revenda foi alterada durante a renovacao do ServicoBusca.");
        }
        return salvarSessao(response.data || {});
    });

    promessa = promessa.then((contexto) => {
        if (renovacaoPendente === promessa) {
            renovacaoPendente = null;
            chaveRenovacao = null;
        }
        return contexto;
    }, (error) => {
        if (renovacaoPendente === promessa) {
            renovacaoPendente = null;
            chaveRenovacao = null;
        }
        return Promise.reject(error);
    });

    renovacaoPendente = promessa;
    chaveRenovacao = chave;

    return renovacaoPendente;
}

function preparar() {
    if (!Store.state.login.xApiKey) {
        return Promise.reject(new Error("Chave de acesso indisponivel para o ServicoBusca."));
    }

    return renovar();
}

function obterContexto() {
    const contexto = obterContextoValido(ler());

    if (contexto) {
        return Promise.resolve(contexto);
    }

    remover();
    return renovar();
}

function salvarSearchId(searchId) {
    const searchIdNormalizado = String(searchId == null ? "" : searchId).trim();

    const sessao = ler();

    if (!sessao || (sessao.searchId || "") === searchIdNormalizado) {
        return;
    }

    if (searchIdNormalizado) {
        sessao.searchId = searchIdNormalizado;
    } else {
        delete sessao.searchId;
    }

    try {
        localStorage.setItem(CHAVE_STORAGE, JSON.stringify(sessao));
    } catch (e) {
        return;
    }
}

function obterSearchId() {
    const sessao = ler();
    return normalizarTexto(sessao && sessao.searchId) || "";
}

export default {
    obterContexto,
    preparar,
    obterSearchId,
    salvarSearchId,
    remover
};
